import React, { useState } from 'react';

const Careers = () => {
  // State for form inputs
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: '',
  });

  // Handle form input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Handle form submit (you can implement actual submit logic here)
  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Thank you for contacting us! We will get back to you soon.');
    setFormData({
      name: '',
      phone: '',
      email: '',
      message: '',
    });
  };

  return (
    <>
      {/* Breadcrumb section */}
      <section
        className="vs-breadcrumb"
        style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
      >
        <div className="container">
          <div className="row text-center">
            <div className="col-12">
              <div className="breadcrumb-content">
                <h1 className="breadcrumb-title">Careers</h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Careers Section */}
      <div className="careers-container p-3 text-center">
        <h1>Let's Join With Us!</h1>
        <p>We're looking for talented individuals to join our growing team.</p>

        {/* Grid Layout for Career Opportunities */}
        <div className="career-cards-container">
          <div className="career-card">
            <h2>Travel Agent</h2>
            <p className='text-white'>Looking for smart, intellectual, and well-skilled agents with 2 years of experience.</p>
            <button className="apply-btn">APPLY NOW</button>
          </div>

          <div className="career-card">
            <h2>Cab Owners</h2>
            <p className='text-white'>Utilize your vehicle at its best and join our team.</p>
            <button className="apply-btn">CONNECT</button>
          </div>

          <div className="career-card">
            <h2>Full-Time Driver</h2>
            <p className='text-white'>Earn more than what you're getting today. Join our team now!</p>
            <button className="apply-btn">APPLY NOW</button>
          </div>

          <div className="career-card">
            <h2>Hotels and Resorts</h2>
            <p className='text-white'>Affiliate with us today to increase your business.</p>
            <button className="apply-btn">JOIN NOW</button>
          </div>
        </div>

       
      </div>
    </>
  );
};

export default Careers;
